module.exports = __webpack_public_path__ + "img/trash-red.7cf87b4c.svg";